// Berekening van Nederlandse feestdagen volgens Meeus/Jones/Butcher algoritme
export function calculateEaster(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;

  // Create date in UTC to avoid timezone issues
  return new Date(Date.UTC(year, month - 1, day));
}

// Helper function for consistent date formatting (timezone-safe)
function formatDateKey(date) {
  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}`;
}

export function getDutchHolidays(year) {
  const easter = calculateEaster(year);
  const holidays = {};

  // Vaste feestdagen
  holidays[`${year}-01-01`] = 'Nieuwjaarsdag';

  // Koningsdag (27 april, verschuift naar 26 april als het op zondag valt)
  const kingsDay = new Date(year, 3, 27); // April is maand 3 (0-indexed)
  if (kingsDay.getDay() === 0) { // Zondag
    holidays[`${year}-04-26`] = 'Koningsdag';
  } else {
    holidays[`${year}-04-27`] = 'Koningsdag';
  }

  // Bevrijdingsdag (5 mei) - wordt vaak als vrije dag gegeven door werkgevers
  holidays[`${year}-05-05`] = 'Bevrijdingsdag';

  holidays[`${year}-12-25`] = '1e Kerstdag';
  holidays[`${year}-12-26`] = '2e Kerstdag';

  // Variabele feestdagen gebaseerd op Pasen
  // Goede Vrijdag wordt niet overal gevierd, maar is officieel erkend
  // const goodFriday = new Date(easter);
  // goodFriday.setDate(easter.getDate() - 2);
  // holidays[formatDateKey(goodFriday)] = 'Goede Vrijdag';

  holidays[formatDateKey(easter)] = '1e Paasdag';

  const easterMonday = new Date(easter);
  easterMonday.setDate(easter.getDate() + 1);
  holidays[formatDateKey(easterMonday)] = '2e Paasdag';

  const ascensionDay = new Date(easter);
  ascensionDay.setDate(easter.getDate() + 39);
  holidays[formatDateKey(ascensionDay)] = 'Hemelvaartsdag';

  const pentecost = new Date(easter);
  pentecost.setDate(easter.getDate() + 49);
  holidays[formatDateKey(pentecost)] = '1e Pinksterdag';

  const pentecostMonday = new Date(easter);
  pentecostMonday.setDate(easter.getDate() + 50);
  holidays[formatDateKey(pentecostMonday)] = '2e Pinksterdag';

  return holidays;
}

export function isWeekend(date) {
  const day = date.getDay();
  return day === 0 || day === 6; // 0 = zondag, 6 = zaterdag
}

export function isHoliday(date, year) {
  const holidays = getDutchHolidays(year);
  const dateString = formatDateKey(date);
  return holidays[dateString] !== undefined;
}

export function getDayName(date) {
  const days = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  return days[date.getDay()];
}

export function getMonthName(month) {
  const months = [
    'januari', 'februari', 'maart', 'april', 'mei', 'juni',
    'juli', 'augustus', 'september', 'oktober', 'november', 'december'
  ];
  return months[month];
}

export function formatDate(date) {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

export function formatDateLong(date) {
  const months = ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'];
  return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
}

export function formatCurrency(amount) {
  const value = typeof amount === 'string' ? amount.replace(',', '.') : amount;
  const numberValue = Number(value);
  if (Number.isNaN(numberValue)) {
    return '€ 0,00';
  }
  return `€ ${numberValue.toFixed(2).replace('.', ',')}`;
}